export const CATEGORIES = {
  SIMULATORS: 'Simulators',
};

export const LABELS = {
  INDIVIDUAL: 'Individual',
  BULK: 'Bulk',
};

export const SIMULATORS = {
  // Navigation events
  READ_TERMINATIONS_SETTLEMENTS: 'ReadTerminationsSettlements',

  // Creation flow events
  CREATE_TERMINATIONS_SETTLEMENTS_BEGIN: 'CreateTerminationsSettlementsBegin',
  CREATE_TERMINATIONS_SETTLEMENTS_SUCCESS: 'CreateTerminationsSettlementsSuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_CANCEL: 'CreateTerminationsSettlementsCancel',
  CREATE_TERMINATIONS_SETTLEMENTS_FAIL: 'CreateTerminationsSettlementsFail',

  // Update flow events
  UPDATE_TERMINATIONS_SETTLEMENTS_BEGIN: 'UpdateTerminationsSettlementsBegin',
  UPDATE_TERMINATIONS_SETTLEMENTS_SUCCESS: 'UpdateTerminationsSettlementsSuccess',
  UPDATE_TERMINATIONS_SETTLEMENTS_CANCEL: 'UpdateTerminationsSettlementsCancel',
  UPDATE_TERMINATIONS_SETTLEMENTS_FAIL: 'UpdateTerminationsSettlementsFail',

  // Incidents flow events
  CREATE_TERMINATIONS_SETTLEMENTS_INCIDENTS_BEGIN: 'CreateTerminationsSettlementsIncidentsBegin',
  CREATE_TERMINATIONS_SETTLEMENTS_INCIDENTS_SUCCESS: 'CreateTerminationsSettlementsIncidentsSuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_INCIDENTS_CANCEL: 'CreateTerminationsSettlementsIncidentsCancel',
  CREATE_TERMINATIONS_SETTLEMENTS_INCIDENTS_FAIL: 'CreateTerminationsSettlementsIncidentsFail',

  // Absenteeism flow events
  CREATE_TERMINATIONS_SETTLEMENTS_ABSENTEEISM_BEGIN: 'CreateTerminationsSettlementsAbsenteeismBegin',
  CREATE_TERMINATIONS_SETTLEMENTS_ABSENTEEISM_SUCCESS: 'CreateTerminationsSettlementsAbsenteeismSuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_ABSENTEEISM_CANCEL: 'CreateTerminationsSettlementsAbsenteeismCancel',
  CREATE_TERMINATIONS_SETTLEMENTS_ABSENTEEISM_FAIL: 'CreateTerminationsSettlementsAbsenteeismFail',

  // Inabilities flow events
  CREATE_TERMINATIONS_SETTLEMENTS_INABILITIES_BEGIN: 'CreateTerminationsSettlementsInabilitiesBegin',
  CREATE_TERMINATIONS_SETTLEMENTS_INABILITIES_SUCCESS: 'CreateTerminationsSettlementsInabilitiesSuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_INABILITIES_CANCEL: 'CreateTerminationsSettlementsInabilitiesCancel',
  CREATE_TERMINATIONS_SETTLEMENTS_INABILITIES_FAIL: 'CreateTerminationsSettlementsInabilitiesFail',

  // Concepts flow events
  CREATE_TERMINATIONS_SETTLEMENTS_CONCEPTS_BEGIN: 'CreateTerminationsSettlementsConceptsBegin',
  CREATE_TERMINATIONS_SETTLEMENTS_CONCEPTS_SUCCESS: 'CreateTerminationsSettlementsConceptsSuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_CONCEPTS_CANCEL: 'CreateTerminationsSettlementsConceptsCancel',
  CREATE_TERMINATIONS_SETTLEMENTS_CONCEPTS_FAIL: 'CreateTerminationsSettlementsConceptsFail',

  // Apply calculation flow events
  CREATE_TERMINATIONS_SETTLEMENTS_APPLY_SUCCESS: 'CreateTerminationsSettlementsApplySuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_APPLY_FAIL: 'CreateTerminationsSettlementsApplyFail',

  // Results flow events
  CREATE_TERMINATIONS_SETTLEMENTS_RESULTS_SUCCESS: 'CreateTerminationsSettlementsResultsSuccess',
  CREATE_TERMINATIONS_SETTLEMENTS_RESULTS_CANCEL: 'CreateTerminationsSettlementsResultsCancel',
  CREATE_TERMINATIONS_SETTLEMENTS_RESULTS_FAIL: 'CreateTerminationsSettlementsResultsFail',
};
